import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router} from '@angular/router';
// import { PdfViewerModule ,} from 'ng2-pdf-viewer';
@Component({
  selector: 'app-pdfpopup',
  templateUrl: './pdfpopup.component.html',
  styleUrls: ['./pdfpopup.component.scss']
})
export class PdfpopupComponent implements OnInit {
  name: any;
  animal: any;


   src = "assets/dummy (1).pdf";
  constructor(public dialog: MatDialog) { }
  pdfpoppopup(): void {
    const dialogRef = this.dialog.open(PdfpopupComponent, {
     
      // data: {name: this.name, animal: this.animal}
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
      this.animal = result;
    });
  }
  ngOnInit() {
  }

}
